module.exports = __webpack_public_path__ + "img/vegan.c295ea77.jpg";